import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from './Home';
import Projects from './Projects';
import Certifications from './Certifications';
import ProjectDetails from './ProjectDetails';
import AboutContainer from './AboutContainer';
import ScrollToTop from './ScrollToTop';

export default class Routes extends Component {
    render() {
        const getProject = (props) => {
            let name = props.match.params.project;
            let project = this.props.projects.find(project => project.title.toLowerCase() === name.toLowerCase());
            return <ProjectDetails {...props} project={project} />
        }
        return (
            <Switch>
                <ScrollToTop>
                    <Route exact path="/About" render={() => <AboutContainer />} />
                    <Route exact path="/Projects" render={() => <Projects projects={this.props.projects} />} />
                    <Route exact path="/Projects/:project" render={getProject} />
                    <Route exact path="/Certifications" render={() => <Certifications />} />
                    <Route exact path="/" render={() => <Home projects={this.props.projects} />} />
                </ScrollToTop>
            </Switch>
        )
    }
}
